export const stringToBool = (string) => {
  if (!string) return false
  return JSON.parse(string.toLowerCase())
}
